import { render } from "./ProfileUpgradeSubscription.vue?vue&type=template&id=4d95ceec"
import script from "./ProfileUpgradeSubscription.vue?vue&type=script&lang=js"
export * from "./ProfileUpgradeSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__